import type { FC } from 'react';

import { QuickGuideControlConnected } from '@pp/core/src/components/nav/navControls/quickGuideControl/QuickGuideControlConnected';
import { useFeature } from '@pp/core/src/services/features/reactBindings/hooks';
import { useIsLargerThanWide } from '@pp/core/src/styles/hooks/media';

import styles from './QuickGuideCell.module.css';

export const QuickGuideCellConnected: FC = () => {
  const isWide = useIsLargerThanWide();
  const newMobileLayout = useFeature('newMobileLayout');

  return !isWide && !newMobileLayout ? (
    <div className={styles.quickGuideCell}>
      <QuickGuideControlConnected />{' '}
    </div>
  ) : null;
};
